import type { StaffAccessLog } from '../api/staff-access-logs.service';

const ACTION_LABELS: Record<string, string> = {
  STAFF_ACCESS_START: 'Sessão iniciada',
  POST: 'Criação',
  PUT: 'Atualização',
  PATCH: 'Atualização parcial',
  DELETE: 'Exclusão',
};

function actionBadge(action: string) {
  const colors: Record<string, string> = {
    STAFF_ACCESS_START: 'bg-violet-100 text-violet-700 border-violet-200',
    DELETE: 'bg-red-100 text-red-700 border-red-200',
    POST: 'bg-green-100 text-green-700 border-green-200',
    PUT: 'bg-blue-100 text-blue-700 border-blue-200',
    PATCH: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  };
  const cls = colors[action] ?? 'bg-gray-100 text-gray-700 border-gray-200';
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${cls}`}>
      {ACTION_LABELS[action] ?? action}
    </span>
  );
}

interface StaffAccessLogTableProps {
  logs: StaffAccessLog[];
  isLoading: boolean;
}

export function StaffAccessLogTable({ logs, isLoading }: StaffAccessLogTableProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="border-b border-gray-100 bg-gray-50">
            <th className="px-4 py-3 text-left font-medium text-gray-600">Staff</th>
            <th className="px-4 py-3 text-left font-medium text-gray-600">Role</th>
            <th className="px-4 py-3 text-left font-medium text-gray-600">Empresa</th>
            <th className="px-4 py-3 text-left font-medium text-gray-600">Ação</th>
            <th className="px-4 py-3 text-left font-medium text-gray-600">Detalhe</th>
            <th className="px-4 py-3 text-left font-medium text-gray-600">IP</th>
            <th className="px-4 py-3 text-left font-medium text-gray-600">Data/Hora</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {isLoading ? (
            <tr>
              <td colSpan={7} className="px-4 py-8 text-center text-gray-400">
                Carregando…
              </td>
            </tr>
          ) : logs.length === 0 ? (
            <tr>
              <td colSpan={7} className="px-4 py-8 text-center text-gray-400">
                Nenhum log de acesso de suporte encontrado.
              </td>
            </tr>
          ) : (
            logs.map((log) => (
              <tr key={log.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900">
                  {log.userEmail ?? log.metadata?.staffEmail ?? '—'}
                </td>
                <td className="px-4 py-3 text-gray-500">{log.metadata?.staffRole ?? '—'}</td>
                <td className="px-4 py-3 text-gray-700">
                  {log.metadata?.targetCompanyName ?? log.companyId ?? '—'}
                </td>
                <td className="px-4 py-3">{actionBadge(log.action)}</td>
                <td className="px-4 py-3 text-gray-500 max-w-xs truncate">
                  {log.metadata?.autoLogged
                    ? `${log.metadata.method} ${log.metadata.path}`
                    : log.entityType !== 'company'
                      ? log.entityType
                      : '—'}
                </td>
                <td className="px-4 py-3 text-gray-400">{log.ipAddress ?? '—'}</td>
                <td className="px-4 py-3 text-gray-400 whitespace-nowrap">
                  {new Date(log.createdAt).toLocaleString('pt-BR')}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
